'use strict';
var util = require('./util');

function aplayProp(cell, row, col) {
  return function(key, defaultValue) {
    if (cell[key] === undefined) {
      if (row[key] !== undefined) {
        cell[key] = row[key];
      } else if (col[key] !== undefined) {
        cell[key] = col[key];
      } else {
        cell[key] = defaultValue;
      }
    }
  }
}

function setTableCellDefaultProps(cell, row, col) {

  var setDefaultProp = aplayProp(cell, row, col);

  setDefaultProp('fontSize', 12);

  setDefaultProp('backColor', '#FFFFFF');

  setDefaultProp('textHAlign', 'HaCenter');

  setDefaultProp('textVAlign', 'VaMiddle');

  setDefaultProp('textColor', "#000000");

  setDefaultProp('fontFamily', "");

  setDefaultProp('textStyles', {});

  setDefaultProp('fontWeight', "Regular");

  setDefaultProp('fontSize', 12);

  setDefaultProp('textWordWrap', true);

  setDefaultProp('cellBorderVisible', true);

  setDefaultProp('cellBorderVisible', true);
  if (cell.cellBorderVisible !== undefined) {
    cell.leftBorderVisible = cell.cellBorderVisible;
    cell.topBorderVisible = cell.cellBorderVisible;
    cell.rightBorderVisible = cell.cellBorderVisible;
    cell.bottomBorderVisible = cell.cellBorderVisible;
  }

  setDefaultProp('cellBorderThinckness', 1);
  if (cell.cellBorderThinckness !== undefined) {
    cell.leftBorderThinckness = cell.cellBorderThinckness;
    cell.topBorderThinckness = cell.cellBorderThinckness;
    cell.rightBorderThinckness = cell.cellBorderThinckness;
    cell.bottomBorderThinckness = cell.cellBorderThinckness;
  }

  setDefaultProp('cellBorderColor', "#C5C5C5");
  if (cell.cellBorderColor !== undefined) {
    cell.leftBorderColor = cell.cellBorderColor;
    cell.topBorderColor = cell.cellBorderColor;
    cell.rightBorderColor = cell.cellBorderColor;
    cell.bottomBorderColor = cell.cellBorderColor;
  }

  setDefaultProp('cellBorderDashMode', "SdSolid");
  if (cell.cellBorderDashMode !== undefined) {
    cell.leftBorderDashMode = cell.cellBorderDashMode;
    cell.topBorderDashMode = cell.cellBorderDashMode;
    cell.rightBorderDashMode = cell.cellBorderDashMode;
    cell.bottomBorderDashMode = cell.cellBorderDashMode;
  }
  setDefaultProp('editIndex', 0);
}

function buildCoords(rows, cols) {
  var horiOff = 0;
  var vertOff = 0;
  var width, height;
  var coords = [];
  for (var i = 0; i < rows.length; i++) {
    height = Math.round(rows[i].height);
    coords.push([]);
    horiOff = 0;
    for (var j = 0; j < cols.length; j++) {
      width = Math.round(cols[j].width);
      var rect = util.Rect.create(horiOff, vertOff, width, height);
      coords[i].push(rect);
      horiOff += width;
    }
    vertOff += height;
  }
  return coords;
}

function buildMatrix(rows, cols, cells) {
  var matrix = [];
  for (var i = 0; i < rows.length; i++) {
    matrix.push([]);
    for (var j = 0; j < cols.length; j++) {
      matrix[i].push({});
    }
  }
  for (var i = 0; i < cells.length; i++) {
    var rowArr = cells[i].rows.split(',');
    var colArr = cells[i].cols.split(',');
    var rowBeginIndex = parseInt(rowArr[0], 10) || 0;
    var rowEndIndex = parseInt(rowArr[1], 10) || 0;
    var colBeginIndex = parseInt(colArr[0], 10) || 0;
    var colEndIndex = parseInt(colArr[1], 10) || 0;
    for (var j = rowBeginIndex; j <= rowEndIndex; j++) {
      for (var k = colBeginIndex; k <= colEndIndex; k++) {
        matrix[j][k] = cells[i];
        setTableCellDefaultProps(cells[i], rows[j], cols[k]);
      }
    }
    delete cells[i].rows;
    delete cells[i].cols;
  }
  return matrix;
}

function getAllCells(matrix, coords) {
  var cells = [];
  for (var i = 0; i < matrix.length; i++) {
    for (var j = 0; j < matrix[0].length; j++) {
      var area = coords[i][j];
      var cell = matrix[i][j];
      if(cell.area === undefined) {
        cell.area = area;
      } else {
        util.Rect.combo(cell.area, area);
      }
      if(cells.indexOf(cell) === -1) {
        cells.push(cell);
      }
    }
  }
  return cells;
}

module.exports = {
  setTableCellDefaultProps: setTableCellDefaultProps,
  buildCoords: buildCoords,
  buildMatrix: buildMatrix,
  getAllCells: getAllCells
};



// WEBPACK FOOTER //
// ./src/helper/tableHelper.js